import styled from 'styled-components'

export const Grid = styled.div`
  margin: 5px 20px 0 20px;
  height: calc(100vh - 235px);
  overflow-y: auto;
`
